export const dropdownElementStyling = {
    lineHeight: '24px',
    padding: 'abc', // bunk to clear unset
    paddingY: '2',
    paddingX: '0',
    fontWeight: 'medium',
    textAlign: 'left',
    alignItems: 'start',
    variant: 'tertiary',
    display: 'block',
    border: 'none',
    width: '100%',
    borderRadius: '8px',
    asAnchor: true,
    color: 'text.primary.light',
};
